import styled from "styled-components";
import { device } from "../../styles/devices";

export const TechStackContent = styled.div`
    background-color: var(--color-white);
    border: 1px solid rgba(0,0,0,0.1);
    border-radius: 0.75rem;
    padding: 1.5rem 1.5rem;
    color: var(--color-text);
    transition: background-color .3s;

    &:hover{
        background-color: var(--color-white-hover);
    }

    @media ${device.tabletLarge}{
        padding: 1.5rem 1rem;
    }

    @media ${device.mobileSmall}{
        padding: 1rem 1rem;
    }

    ul{
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 1rem;

        @media ${device.tablet}{
            grid-template-columns: repeat(2, 1fr);
        }
        @media ${device.mobileSmall}{
            gap: 0.6rem;
        }
    }

    h3{
        font-size: 1.5rem;
        font-weight: var(--font-bold);
        line-height: 2rem;
        color: var(--color-title);
        text-align: center;
        margin-bottom: 1rem;

        @media ${device.mobileSmall}{
            font-size: 1.2rem;
            line-height: 1.7rem;
        }
    }

`;